<template>
    <base-spinner :open="isloading"></base-spinner>
    <base-message
        v-if="!isloading"
        :servermessages="servermessages"
    ></base-message>
    <div class="site__body">
        <div class="block-space block-space--layout--after-header"></div>
        <div class="block">
            <div class="container container--max--xl">
                <div class="row">
                    <account-navigation :active-page="'saved-payment-methods'"></account-navigation>
                    <account-payment-list :savedcards="savedcardslist" @confirm-remove="confirmRemove"></account-payment-list>
                </div>
            </div>
        </div>
        <div class="block-space block-space--layout--before-footer"></div>
    </div>
</template>

<script>
import AccountNavigation from '../accountnavigation/AccountNavigation';
import AccountPaymentList from './AccountPaymentList';
import axiosvl from "../../../axios/axios-vl.js";

export default {
    name: 'AccountPayments',
    components: {
        AccountNavigation,
        AccountPaymentList    
    },
    data() {
        return {
            savedcardslist: [],
            isloading: false,
            servermessages: []
        }
    },
    methods: {
        getSavedCards() {
            this.isloading = true;
            this.savedcardslist = [];

            axiosvl.post(this.$store.getters['api/get_saved_cc_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields
                const messages = [];

                if (fields.RESULTCOD.value === 'OK') {
                    const results = [];

                    for (const key in response.data.webroutine.lists.SCCS.entries) {
                        const obj = response.data.webroutine.lists.SCCS.entries[key];
                        results.push({
                            name: obj.ADNAME,
                            last4digits: obj.PPIL4,
                            tendertype: obj.PPITNT,
                            savednumber: obj.PPISCCN,
                            // !NC!
                            expirymonth: '01 (x)',
                            expiryyear: '2111 (x)'
                        });
                    }
                    this.savedcardslist = results;
                } else {
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }

                    // Return code is not "OK" but no messages appear, add a custom error message
                    if (messages.length === 0) {
                        messages.push("Something went wrong. Please try again later.");
                    }
                }

                this.isloading = false;
                this.servermessages = messages;
            })
            .catch((error) => {
                this.isloading = false;
                console.error("error - " + error);
            });
        },
        confirmRemove(index) {
            this.isloading = true;
            
            axiosvl.post(this.$store.getters['api/removed_saved_cc_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                        "CCSAVED": {"value": this.savedcardslist[index].savednumber }
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields
                const messages = [];

                if (fields.RESULTCOD.value === 'OK') {
                    this.getSavedCards();
                } else {
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }

                    // Return code is not "OK" but no messages appear, add a custom error message
                    if (messages.length === 0) {
                        messages.push("Something went wrong. Please try again later.");
                    }

                    this.isloading = false;
                    this.servermessages = messages;
                }
            })
            .catch((error) => {
                this.isloading = false;
                console.error("error - " + error);
            });
        }
    },
    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
        this.getSavedCards();
    }
    
}
</script>
